<div class="menu" *ngIf="active">
  <div class="notif-panel__header">
    <h2 class="notif-panel__title">Notifications</h2>
    <button
      type="button"
      class="documents-dialog__content__close"
      data-testid="notifications-close"
      (click)="closeDialog()"
      aria-label="Close notifications"
    >
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="notif-panel__tabs">
    <button
      type="button"
      class="tab-btn notif-panel__tab"
      [class.notif-panel__tab--active]="activeTab == 'all'"
      data-testid="notifications-tab-all"
      (click)="toggleTab('all')"
    >
      All
    </button>
    <button
      type="button"
      class="tab-btn notif-panel__tab"
      [class.notif-panel__tab--active]="activeTab == 'unread'"
      data-testid="notifications-tab-unread"
      (click)="toggleTab('unread')"
    >
      Unread
    </button>
    <button
      type="button"
      class="tab-btn notif-panel__tab"
      [class.notif-panel__tab--active]="activeTab == 'read'"
      data-testid="notifications-tab-read"
      (click)="toggleTab('read')"
    >
      Read
    </button>
    <button
      type="button"
      class="tab-btn notif-panel__tab notif-panel__tab--link"
      [disabled]="unreadNotifications?.length === 0"
      data-testid="notifications-mark-all-read"
      (click)="markAllNotificationsRead()"
    >
      Mark All As Read
    </button>
  </div>

  <div class="notif-panel__body">
    <div *ngIf="activeTab == 'all'">
      <div *ngIf="allNotifications.length === 0; else all">
        <p class="placeholder">No notifications.</p>
      </div>
      <ng-template #all>
        <div
          class="notif-panel__item"
          [class.notif-panel__item--unread]="!entry.isRead"
          *ngFor="let entry of allNotifications; let i = index; trackBy: trackByEntry"
        >
          <mat-icon
            *ngIf="entry.notification.type === 'ERROR'"
            class="notif-panel__error-icon"
            >error</mat-icon
          >
          <p
            class="notif-panel__content"
            [attr.data-testid]="allTestIds[i] + '-content'"
            (click)="notificationClick(entry.notification)"
          >
            <span class="subject">{{ entry.notification.subject }}</span>
            <br />
            <span class="notif-panel__message">{{
              entry.notification.body
            }}</span>
            <br />
            <span class="notif-panel__date">{{
              entry.notification.createdOn | date : "MM-dd-yyyy hh:mm a" : locale
            }}</span>
          </p>
          <span
            *ngIf="!entry.isRead"
            class="material-icons notif-panel__action"
            matTooltip="Mark As Read"
            matTooltipPosition="above"
            [attr.data-testid]="allTestIds[i] + '-mark-read'"
            (click)="markNotificationRead(entry.notification)"
            >hide_source</span
          >
          <span
            *ngIf="entry.isRead"
            class="material-icons notif-panel__action"
            matTooltip="Mark As Unread"
            matTooltipPosition="above"
            [attr.data-testid]="allTestIds[i] + '-mark-unread'"
            (click)="markNotificationUnread(entry.notification)"
            >radio_button_unchecked</span
          >
        </div>
      </ng-template>
    </div>
    <div *ngIf="activeTab == 'unread'">
      <div *ngIf="unreadNotifications?.length === 0; else unread">
        <p class="placeholder">No unread notifications.</p>
      </div>
      <ng-template #unread>
        <div
          class="notif-panel__item notif-panel__item--unread"
          *ngFor="let notification of unreadNotifications; let i = index; trackBy: trackByNotification"
        >
          <mat-icon
            *ngIf="notification.type === 'ERROR'"
            class="notif-panel__error-icon"
            >error</mat-icon
          >
          <p
            class="notif-panel__content"
            [attr.data-testid]="unreadTestIds[i] + '-content'"
            (click)="notificationClick(notification)"
          >
            <span class="subject">{{ notification.subject }}</span>
            <br />
            <span class="notif-panel__message">{{ notification.body }}</span>
            <br />
            <span class="notif-panel__date">{{
              notification.createdOn | date : "MM-dd-yyyy hh:mm a" : locale
            }}</span>
          </p>
          <span
            class="material-icons notif-panel__action"
            matTooltip="Mark As Read"
            matTooltipPosition="above"
            [attr.data-testid]="unreadTestIds[i] + '-mark-read'"
            (click)="markNotificationRead(notification)"
            >hide_source</span
          >
        </div>
      </ng-template>
    </div>
    <div *ngIf="activeTab == 'read'">
      <div *ngIf="readNotifications?.length === 0; else read">
        <p class="placeholder">No previously read notifications.</p>
      </div>
      <ng-template #read>
        <div
          class="notif-panel__item"
          *ngFor="let notification of readNotifications; let i = index; trackBy: trackByNotification"
        >
          <mat-icon
            *ngIf="notification.type === 'ERROR'"
            class="notif-panel__error-icon"
            >error</mat-icon
          >
          <p
            class="notif-panel__content"
            [attr.data-testid]="readTestIds[i] + '-content'"
            (click)="notificationClick(notification)"
          >
            <span class="subject">{{ notification.subject }}</span>
            <br />
            <span class="notif-panel__message">{{ notification.body }}</span>
            <br />
            <span class="notif-panel__date"
              >Received at
              {{
                notification.createdOn | date : "MM-dd-yyyy hh:mm a" : locale
              }}</span
            >
          </p>
          <span
            class="material-icons notif-panel__action"
            matTooltip="Mark As Unread"
            matTooltipPosition="above"
            [attr.data-testid]="readTestIds[i] + '-mark-unread'"
            (click)="markNotificationUnread(notification)"
            >radio_button_unchecked</span
          >
        </div>
      </ng-template>
    </div>
  </div>
</div>
